"use client";

import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { motion } from "motion/react";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <button
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className="relative w-12 h-12 flex items-center justify-center bg-neutral-900 border border-neutral-800 rounded-2xl text-white hover:border-violet-500 transition-all group overflow-hidden"
      aria-label="Toggle theme"
    >
      <motion.div
        initial={false}
        animate={{ y: theme === "dark" ? 0 : 40 }}
        className="absolute"
      >
        <Sun size={20} className="text-yellow-400" />
      </motion.div>
      <motion.div
        initial={false}
        animate={{ y: theme === "light" ? 0 : -40 }}
        className="absolute"
      >
        <Moon size={20} className="text-violet-400" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-br from-violet-500/10 to-fuchsia-500/10 opacity-0 group-hover:opacity-100 transition-opacity" />
    </button>
  );
}